import { LayoutTitle } from '.';
import React, { ReactNode } from 'react';
import { SubtitleWrapper } from './index.styles';
import { Heading } from '@zopauk/react-components';

interface IRenderTitleProps {
  titleElement: React.JSX.Element | null;
  titleText?: string;
}

const renderTitle = (title: LayoutTitle = '', subtitle?: ReactNode): IRenderTitleProps => {
  const titleText = typeof title === 'string' ? title : title.text;
  const showHeaderTitle = typeof title === 'string' || !title.noHeaderTitle;

  return {
    titleElement: showHeaderTitle ? (
      <>
        <Heading as="h2">{titleText}</Heading>
        {subtitle ? <SubtitleWrapper>{subtitle}</SubtitleWrapper> : null}
      </>
    ) : null,
    titleText,
  };
};

export default renderTitle;
